import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoPaymentAmex, LazySvgoPaymentJcb, LazySvgoPaymentMastercard, LazySvgoPaymentUnionpay, LazySvgoPaymentUnknown, LazySvgoPaymentVisa, LazySvgoCheckmarkCircle, LazySvgoCheckmark, LazySvgoChevronRight, LazySvgoClock, LazySvgoCopy, LazySvgoExclamationCircle, LazySvgoGlobe, LazySvgoGuests, LazySvgoInfoCircle, LazySvgoLocation, LazySvgoLock, LazySvgoLogo, LazySvgoMap, LazySvgoPlus, LazyProseA, LazyProseBlockquote, LazyProseCode, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseImg, LazyProseLi, LazyProseOl, LazyProseP, LazyProsePre, LazyProseScript, LazyProseStrong, LazyProseTable, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["SvgoPaymentAmex", LazySvgoPaymentAmex],
["SvgoPaymentJcb", LazySvgoPaymentJcb],
["SvgoPaymentMastercard", LazySvgoPaymentMastercard],
["SvgoPaymentUnionpay", LazySvgoPaymentUnionpay],
["SvgoPaymentUnknown", LazySvgoPaymentUnknown],
["SvgoPaymentVisa", LazySvgoPaymentVisa],
["SvgoCheckmarkCircle", LazySvgoCheckmarkCircle],
["SvgoCheckmark", LazySvgoCheckmark],
["SvgoChevronRight", LazySvgoChevronRight],
["SvgoClock", LazySvgoClock],
["SvgoCopy", LazySvgoCopy],
["SvgoExclamationCircle", LazySvgoExclamationCircle],
["SvgoGlobe", LazySvgoGlobe],
["SvgoGuests", LazySvgoGuests],
["SvgoInfoCircle", LazySvgoInfoCircle],
["SvgoLocation", LazySvgoLocation],
["SvgoLock", LazySvgoLock],
["SvgoLogo", LazySvgoLogo],
["SvgoMap", LazySvgoMap],
["SvgoPlus", LazySvgoPlus],
["ProseA", LazyProseA],
["ProseBlockquote", LazyProseBlockquote],
["ProseCode", LazyProseCode],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseImg", LazyProseImg],
["ProseLi", LazyProseLi],
["ProseOl", LazyProseOl],
["ProseP", LazyProseP],
["ProsePre", LazyProsePre],
["ProseScript", LazyProseScript],
["ProseStrong", LazyProseStrong],
["ProseTable", LazyProseTable],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
